import type { NotificationCondition } from 'types/templateNotificationConditions';
import type { HeliosNotificationConditionsState, ConditionType } from '..';

export const updateCondition = (
  state: HeliosNotificationConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      index: number;
      condition: NotificationCondition;
    };
  }
) => {
  if (state[payload.type]?.conditions) {
    state[payload.type]!.conditions![payload.index] = payload.condition;
  }
};
